<template>
  <sliderBarDialogShell
    ref="sliderbar"
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="close"
    @submit="confirm"
    class="editline-dialog"
  >
    <Form
      ref="form"
      :form-data="formData"
      @submit="submitHandle"
    ></Form>
  </sliderBarDialogShell>
</template>

<script>
import { editLineConfig } from "@/api/sys/robitConfig/line";
import Form from '@/components/sys/robitCofig/line/Form'

export default {
  name: 'edit',
  components:{
      Form,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
    }
  },
  data() {
    return {
      title: '修改line推送渠道'
    }
  },
  methods: {
    close(){
      this.$refs.form.$refs.form.clearValidate();
      this.$emit('close');
    },
    cancel(){
      this.close();
    },
    confirm() {
      this.$refs.form.validate();
    },
    submitHandle(formData){
        let params = {
          id: formData.id,
          channelId: formData.channelId,
          channelName: formData.channelName,
          accessToken: formData.accessToken,
          channelSecret: formData.channelSecret,
          remark: formData.remark,
          status: formData.status
        }
        editLineConfig(params).then((res) => {
            this.$refs.form.$refs.form.clearValidate();
            this.$refs.form.$refs.form.resetFields();
            this.$emit('edit-success');
            this.$refs.form.reset();
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.addlinks-dialog {
  .el-select {
    width: 100%;
  }
}
</style>
<style lang="scss">
@media screen and (min-width: 768px) {
  .editline-dialog.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}

</style>
